import { useId, type TextareaHTMLAttributes } from "react";

export interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  helperText?: string;
  onValueChange?: (value: string) => void;
}

export function TextArea({
  label,
  helperText,
  onChange,
  onValueChange,
  id,
  className,
  ...props
}: TextAreaProps) {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  return (
    <label className={["ui-textarea", className].filter(Boolean).join(" ")}>
      <span>{label}</span>
      <textarea
        {...props}
        id={inputId}
        onChange={(event) => {
          onChange?.(event);
          onValueChange?.(event.target.value);
        }}
      />
      {helperText && <small>{helperText}</small>}
    </label>
  );
}
